<template>
  <div class="alert-wrap z-1000">
    <transition-group :name="transition" tag="div">
      <notification
        class="relative mb-2 shadow-md border rounded"
        v-for="(item, index) in notifications"
        :key="item.id"
        :message="item.message"
        :level="item.level"
        :important="item.important"
        :with-datetime="item.withDatetime"
        :autohide="item.autohide"
        role="alert"
        @hide="hide(index)"
      >
      </notification>
      <div
        class="flex justify-center pt-3 pb-2 -mt-2"
        v-if="showReadAllButton"
        key="read-all-flash-notifications"
      >
        <ranch-button
          @click="readAll"
          :label="i18n.read_all"
          size="sm"
          icon="trash-alt"
        ></ranch-button>
      </div>
    </transition-group>
  </div>
</template>
<script>
import Notification from "./Notification";

export default {
  components: { Notification },
  props: {
    messages: {},
  },

  data: function () {
    return {
      notifications: [],
      transition: "slide-fade",
    };
  },

  computed: {
    showReadAllButton() {
      return this.notifications.length > 1;
    },
    i18n() {
      return this.$store.state.app.i18n.components.flash;
    },
  },

  created() {
    window.events.$on("flash", (message, level, important, withDatetime) =>
      this.flash(message, level, important, withDatetime)
    );
  },

  mounted() {
    if (this.messages.length > 0) {
      for (var i = 0, len = this.messages.length; i < len; i++) {
        this.flash(
          this.messages[i].message,
          this.messages[i].level,
          this.messages[i].important,
          this.messages[i].withDatetime
        );
      }
    }
  },

  methods: {
    flash(message, level, important, withDatetime) {
      let notification = {
        id: Math.random().toString(36).slice(2),
        message: message,
        important: important,
        level: level,
        withDatetime: withDatetime,
      };

      this.notifications.push(notification);
    },

    hide(item) {
      this.notifications.splice(item, 1);
    },

    readAll() {
      this.notifications = [];
    },
  },
};
</script>
